export default __webpack_public_path__ + "static/media/0.01e35644.jpg";